<template>
  <button
    class="fixed bottom-20 lg:bottom-62 right-0 px-2 py-3 bg-white border-t border-b border-l border-gray-200 flex items-center justify-center cursor-pointer z-10"
    @click="onClick"
  >
    <svg-icon name="question-bubble" class="text-2xl" />
  </button>

  <contact-overlay v-if="isOverlayOpen" @close="isOverlayOpen = false" />
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { TrackingEventType } from '@/enums'
import trackingService from '@/services/amplitude/tracking.service'
import SvgIcon from '@/components/SvgIcon.vue'
import ContactOverlay from '@/components/ContactOverlay.vue'

const isOverlayOpen = ref(false)

const onClick = () => {
  trackingService.trackEvent(TrackingEventType.MAIN_SCREEN_CONTACT_CLICKED)
  isOverlayOpen.value = true
}
</script>
